/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Workspace_DescInputs */



/**
* | output |
* | --- |
* | "Your team, an activity log and your own bot" |
*
* @param {Products_Menu_Workspace_DescInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_workspace_desc = /** @type {((inputs?: Products_Menu_Workspace_DescInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Workspace_DescInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваша команда, журнал активности и собственный бот")
	return /** @type {LocalizedString} */ ("Your team, an activity log and your own bot")
});